/**
 * SettingsIcon — sanitized from `assets/newSvg/settings.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function SettingsIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M16.5,12 C18.9853,12 21,14.0147 21,16.5 C21,18.9142914 19.0987811,20.8844901 16.7118372,20.9951021 L16.5,21 L7.5,21 C5.01472,21 3,18.9853 3,16.5 C3,14.0857086 4.90123781,12.1155099 7.28816441,12.0048979 L7.5,12 L16.5,12 Z M7,14.5 C5.89543,14.5 5,15.3954 5,16.5 C5,17.6046 5.89543,18.5 7,18.5 C8.10457,18.5 9,17.6046 9,16.5 C9,15.3954 8.10457,14.5 7,14.5 Z M16.5,2 C18.9853,2 21,4.01472 21,6.5 C21,8.914272 19.0987811,10.884489 16.7118372,10.995102 L16.5,11 L7.5,11 C5.01472,11 3,8.98528 3,6.5 C3,4.085728 4.90123781,2.11551099 7.28816441,2.00489799 L7.5,2 L16.5,2 Z M17,4.5 C15.8954,4.5 15,5.39543 15,6.5 C15,7.60457 15.8954,8.5 17,8.5 C18.1046,8.5 19,7.60457 19,6.5 C19,5.39543 18.1046,4.5 17,4.5 Z"
        fill={color}
      />
    </Svg>
  );
}

export default SettingsIcon;
